import { render } from "./BottomNav.vue?vue&type=template&id=49b3ecf8&scoped=true"
const script = {}

import "./BottomNav.vue?vue&type=style&index=0&id=49b3ecf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b3ecf8"]])

export default __exports__